import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { boolean } from "yup";

interface PopupState {
  isDeletePopupOpen: boolean;
  isDeactivePopupOpen: boolean;
  entityType: string | null; // Type of entity (e.g., "product", "category", etc.)
  entityData: any; // Data of the entity to be deleted
  entityStatus: boolean
  done: boolean;
}

const initialState: PopupState = {
  isDeletePopupOpen: false,
  isDeactivePopupOpen: false,
  entityType: null,
  entityData: null,
  entityStatus: false,
  done: false,
};

// Generic thunk to open the delete popup
export const openDeletePopup = createAsyncThunk(
  "popup/open",
  async ({ entityType, entityData }: { entityType: string; entityData: any }) => {
    return { entityType, entityData };
  }
);

export const openDeactivePopup = createAsyncThunk("popup/openDeactive", async ({ entityType, entityData, entityStatus }:{ entityType: string; entityData: any; entityStatus: boolean }) => {
  return { entityType, entityData, entityStatus };
})

// Generic thunk to confirm the delete action
export const confirmDeletePopup = createAsyncThunk(
  "popup/confirm",
  async (
    { entityType, entityData }: { entityType: string; entityData: any },
    thunkAPI
  ) => {
    // Perform the delete logic here based on entityType
    // e.g., dispatch a delete action or call an API
    // Example:
    // if (entityType === "product") {
    //   await thunkAPI.dispatch(deleteProduct(entityData.id));
    // } else if (entityType === "category") {
    //   await thunkAPI.dispatch(deleteCategory(entityData.id));
    // }
    return { entityType, entityData };
  }
);

export const confirmDeactivePopup = createAsyncThunk("popup/confirmDeactive", async ({ entityType, entityData, entityStatus } : {entityType: string; entityData: any; entityStatus: boolean}, thunkAPI) => {
  return { entityType, entityData, entityStatus };
})

export const DeletePopup = createSlice({
  name: "delete-popup",
  initialState,
  reducers: {
    closePopup: (state) => {
      state.isDeletePopupOpen = false;
      state.isDeactivePopupOpen = false;
      state.entityType = null;
      state.entityData = null;
      state.entityStatus = false;
      state.done = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle opening the popup
      .addCase(openDeletePopup.pending, (state) => {
        state.isDeletePopupOpen = false;
        state.entityType = null;
        state.entityData = null;
      })
      .addCase(openDeletePopup.fulfilled, (state, action) => {
        state.isDeletePopupOpen = true;
        state.entityType = action.payload.entityType;
        state.entityData = action.payload.entityData;
      })
      .addCase(openDeletePopup.rejected, (state) => {
        state.isDeletePopupOpen = false;
        state.entityType = null;
        state.entityData = null;
      })

      //open deactive popup
      .addCase(openDeactivePopup.pending, (state) => {
        state.isDeactivePopupOpen = false;
        state.entityType = null;
        state.entityData = null;
        state.entityStatus = false;
      })
      .addCase(openDeactivePopup.fulfilled, (state, action) => {
        state.isDeactivePopupOpen = true;
        state.entityType = action.payload.entityType;
        state.entityData = action.payload.entityData;
        state.entityStatus = action.payload.entityStatus;
      })
      .addCase(openDeactivePopup.rejected, (state) => {
        state.isDeactivePopupOpen = false;
        state.entityType = null;
        state.entityData = null;
        state.entityStatus = false;
      })

      // Handle confirming the delete
      .addCase(confirmDeletePopup.pending, (state) => {
        state.done = false;
      })
      .addCase(confirmDeletePopup.fulfilled, (state, action) => {
        // console.log("action.payload", action.payload);
        state.isDeletePopupOpen = false;
        state.done = true;
        state.entityType = action.payload.entityType;
        state.entityData = action.payload.entityData;
      })
      .addCase(confirmDeletePopup.rejected, (state) => {
        state.done = true;
        state.isDeletePopupOpen = false;
      })

      // Handle confirming the deactive
      .addCase(confirmDeactivePopup.pending, (state) => {
        state.done = false;
      })
      .addCase(confirmDeactivePopup.fulfilled, (state, action) => {
        state.isDeactivePopupOpen = false;
        state.done = true;
        state.entityType = action.payload.entityType;
        state.entityData = action.payload.entityData;
        state.entityStatus = action.payload.entityStatus;
      })
      .addCase(confirmDeactivePopup.rejected, (state) => {
        state.done = true;
        state.isDeactivePopupOpen = false;
      })

      // Default case to reset `done`
      .addDefaultCase((state) => {
        state.done = false;
      });
  },
});

export const { closePopup } = DeletePopup.actions;
export default DeletePopup.reducer;
